import { Button } from "ui/components/Button/Button";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { transformRoute, useTranslate } from "helpers";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleExpenseHeaderProps } from "./types";

const VehicleExpenseHeader = ({
    vehicleId,
    onAdd,
}: VehicleExpenseHeaderProps) => {
    const { t } = useTranslate();

    return (
        <div className="flex items-center gap-2">
            <ButtonLink
                size="small"
                variant="warning"
                children={t("admin.fleet.vehicle.expense.detail")}
                to={transformRoute(
                    FleetVehicleRoutes.FleetVehicleExpenseSearchPageRouter,
                    {
                        id: vehicleId,
                    }
                )}
                startIcon="/media/icons/search.svg"
            />
            <Button
                size="small"
                variant="secondary"
                children={t("admin.fleet.vehicle.expense.add")}
                onClick={onAdd}
                startIcon="/media/icons/plus.svg"
            />
        </div>
    );
};

export default VehicleExpenseHeader;
